import axios from 'axios';

export const creditNoteApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-credit-note`,
    headers: {
        'Content-Type': 'application/json'
    }
})